import {
  View,
  Text,
  Dimensions,
  TouchableOpacity,
  Image,
  Platform,
} from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";
import { useSelector } from "react-redux";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { orange, primary } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { appUpdate, noMoney } from "../../imports";
import { useNavigation } from "@react-navigation/native";
import * as Linking from "expo-linking";

const APP_VERSION = "1.0.1";
export default function UpdateModal() {
  const user = useSelector((store) => store.user);
  

  const openLink = () => {
    Linking.openURL(
      Platform.OS === "android"
        ? "https://asqtest.ir/files/ASQ.apk"
        : "https://asqtest.ir/"
    );
  };

  return (
    <MyModal
      noX
      isVisible={
        Platform.OS !== "web" &&
        user.version !== null &&
        user.version !== undefined &&
        +APP_VERSION.split(".").join("") < +user.version.split(".").join("")
      }
    >
      <View
        style={{
          width: "100%",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Image
          resizeMode="contain"
          source={appUpdate}
          style={{ width: "100%", marginBottom: 10, height: 240 }}
        />
        <View style={{ width: "90%", marginBottom: 10 }}>
          <MyText style={{ textAlign: "center" }}>
            {translate("update required #full text")}
          </MyText>
        </View>
        <View style={{ marginBottom: 10 }}>
          <MyButton text={translate("Download App")} onPress={openLink} />
        </View>
      </View>
    </MyModal>
  );
}
